<template>
    <div class="xy-start question-rule">
        <el-descriptions title="组卷规则">
            <el-descriptions-item label="所属分类">{{ClassName || "全部"}}</el-descriptions-item>
            <el-descriptions-item label="试题难度">{{RoleHardLevel || "全部"}}</el-descriptions-item>
            <el-descriptions-item label="题型">{{RoleSubjectTypeId || "全部"}}</el-descriptions-item>
            <el-descriptions-item label="用途">{{RoleUseType || "全部"}}</el-descriptions-item>
            <el-descriptions-item label="试题数量">{{rule.RoleSubNum}}题</el-descriptions-item>
        </el-descriptions>
        <div class="edit-que yx-center jf-start al-end no-shrink">
            <div class="xy-center score no-shrink">
                <span style="margin-right: 10px">每题</span>
                <el-input v-model.number="subScore"></el-input>
                <span class="font-size18"> 分</span>
            </div>
            <div class="icon xy-center jf-start">
                <el-popconfirm
                    title="确定删除当前组卷规则吗？"
                    @confirm="$emit('del')"
                >
                    <i class="iconfont" slot="reference">&#xe6b9;</i>
                </el-popconfirm>

                <i class="iconfont" @click="$emit('goBehind')"
                >&#xe6ba;</i
                >
                <i class="iconfont" @click="$emit('goAhead')"
                >&#xe6ba;</i
                >
            </div>
        </div>
    </div>
</template>

<script>
import { CommonPage } from "@/mixins/commonData";

export default {
    name: "QuestionRule",
    mixins: [CommonPage],
    inject: ["organClass"],
    props: {
        rule: {
            type: Object,
            required: true
        },
        randomScore: {
            type: Number,
            default: 0
        },
    },
    computed: {
        RoleHardLevel() {
            return this.difficultyData.find(el => el.value === this.rule.RoleHardlevel)?.name
        },
        RoleSubjectTypeId() {
            return this.queTypeData.find(el => el.value === this.rule.RoleSubjectTypeId)?.name
        },
        RoleUseType() {
            return this.useForData.find(el => el.value === this.rule.RoleUseType)?.name
        },
        ClassName() {
            return this.findCategoryNameById(this.rule.RoleClassId)
        },
        subScore: {
            get() {
                return this.randomScore
            },
            set(val) {
                this.$emit("update:randomScore", val)
            }
        }
    },
    watch: {
        randomScore(newValue, oldValue) {
            this.rule.SubScore = newValue;
        }
    },
    methods: {
        findCategoryNameById(id) {
            const work = (children) => {
                for (const category of children) {
                    if (category.ClassId === id) {
                        return category.ClassName
                    }
                    if (category.children) {
                        let name = work(category.children)
                        if (name) return name
                    }
                }
            }
            return work(this.organClass)
        }
    },
}
</script>

<style scoped lang="less">
.question-rule {
    margin-bottom: 20px;
    .edit-que::v-deep {
        margin-left: 20px;
        .score {
            margin-bottom: 28px;
            .el-input {
                width: 50px;
                height: 28px;
                border-radius: 2px;
                margin-right: 10px;
                input {
                    height: 28px;
                }
            }
        }
        .icon {
            i {
                color: #256cf4;
                font-size: 15px;
                line-height: 1;
                margin-left: 10px;
                cursor: pointer;
                display: inline-block;
            }
            i:nth-of-type(1) {
                margin-top: 3px;
            }
            i:nth-of-type(2) {
                display: inline-block;
                transform: rotate(180deg);
                margin-top: -2px;
            }
        }
    }
}
</style>
